/*
 * @Author: wangyan
 * @Description:
 * @Date: 2022-05-05 10:37:30
 * @LastEditTime: 2022-05-05 14:28:27
 * @FilePath: /teacher-h5/src/store/modules/common.js
 */
const state = {
  gradeList: [],
  subjectList: [],
  activeGradeId: -1,
  activeParentId: -1
}

// 自定义改变state初始值的方法
const mutations = {
  setGradeList(state, data) {
    state.gradeList = data
  },
  setSubjectList(state, data) {
    state.subjectList = data
  },
  setActiveGradeId(state, data) {
    state.activeGradeId = data
  },
  setActiveParentId(state, data) {
    state.activeParentId = data
  }
}

// 自定义触发mutations里函数的方法
const actions = {
}

const getters = {
  // 班级
  gradeList: state => state.gradeList,
  // 学科
  subjectList: state => state.subjectList,
  activeGradeId: state => state.activeGradeId,
  activeParentId: state => state.activeParentId
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
